<template>
  <div>
    <div class="common-box margin-t10">
      <el-row class="row-one">
        <span class="row-one-title">公募基金资产信息</span>
        <Reback v-show="this.$route.name !== 'myAssets'" class="row-one-fr" @click.native="returnClick"></Reback>
      </el-row>
      <el-radio-group class="radio-single-btn margin-t20" v-model="radioPublic" size="medium">
        <el-radio-button label="1">持仓信息{{ ' ( '+publicTableData.length+' ) '}}</el-radio-button>
      </el-radio-group>
      <el-row class=" margin-t20">
        <el-col :span="4">
          <!-- 选择框 -->
          <el-select v-model="bankCardValue" placeholder="请选择银行卡" style="margin-right: 30px;" @change="selectBankCard">
            <el-option v-for="item in bankCardOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select @change="reorder" v-model="marketValue" placeholder="请选择排序方式" style="margin-right: 37px;">
            <el-option v-for="item in marketOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input class="inputOne" placeholder="基金代码/名称" suffix-icon="el-input__icon el-icon-search" v-model="searchInput">
          </el-input>
        </el-col>

      </el-row>
      <!-- 表格 -->
      <el-table v-loading="loading" element-loading-text="加载中..." :data="publicTableData" class="table-single table-public  margin-t20 loding-one" style="width: 100%;" :cell-style="set_cell_style">
        <el-table-column width="50">
          <template slot-scope="scope">
            <span style="padding-left: 5px;">{{scope.$index+1}}</span>
            <el-tooltip v-if="scope.row.InfoTitle" class="item" effect="light" :popper-class="(scope.row.InfoTitle.indexOf('分红') !=-1 || scope.row.InfoTitle.indexOf('收益分配') !=-1 || scope.row.MS=='收益分配' )?'table-public-red':'table-public-blue'" placement="right">
              <div slot="content">
                　<span>{{scope.row.InfoTitle}}</span>
                　<span style="padding: 0 12px;">{{scope.row.noticeTime}}</span>
                <a class="font-blod aColor" :href="'https://www.myfund.com/fundNewsContent.html?fundCode='+scope.row.fundcode +'&ID='+scope.row.noticeId" target="_blank">查看详情</a>
              </div>
              <div v-if="scope.row.InfoTitle" style="display:inline-block;float:right;">
                <img v-if="scope.row.InfoTitle.indexOf('分红') != -1 || scope.row.InfoTitle.indexOf('收益分配') != -1 || scope.row.MS == '收益分配'" src="../../../assets/images/notice1.png" alt="">
                <img v-else src="../../../assets/images/notice2.png" alt="">
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="fundcode" label="基金代码" width="76"></el-table-column>
        <el-table-column prop="fundcodename" label="基金名称" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundcodename" placement="right">
              <a style="text-align: left;" :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundcode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundcodename}}</a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="nav" label="最新净值" width="80">
        </el-table-column>
        <el-table-column prop="navdate" label="更新日期" width="56">
        </el-table-column>
        <el-table-column prop="fundvol" label="基金份额" width="72">
        </el-table-column>
        <el-table-column prop="availbal" label="可用份额" width="72">
        </el-table-column>
        <el-table-column prop="mktvalue" label="当前市值" width="72">
        </el-table-column>
        <el-table-column prop="yestdayprofit" label="昨日收益">
          <template slot-scope="scope">
            <span v-if="scope.row.yestdayprofit > 0" class="rColor">{{'+'+scope.row.yestdayprofit}}</span>
            <span v-else-if="scope.row.yestdayprofit < 0" class="gColor">{{scope.row.yestdayprofit}}</span>
            <span v-else>{{scope.row.yestdayprofit}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dailyincreases" label="日涨跌幅" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.dailyincreases > 0" class="rColor">{{'+'+parseFloat(scope.row.dailyincreases*100).toFixed(2)}}%</span>
            <span v-else-if="scope.row.dailyincreases < 0" class="gColor">{{parseFloat(scope.row.dailyincreases*100).toFixed(2)}}%</span>
            <span v-else>{{parseFloat(scope.row.dailyincreases*100).toFixed(2)}}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="phaseprofit" label="持有收益" width="87">
          <template slot-scope="scope">
            <span v-if="scope.row.phaseprofit > 0" class="rColor">{{'+'+scope.row.phaseprofit}}</span>
            <span v-else-if="scope.row.phaseprofit < 0" class="gColor">{{scope.row.phaseprofit}}</span>
            <span v-else>{{scope.row.phaseprofit}}</span>
            <!-- <span :class="scope.row.phaseprofit >= 0? 'rColor':'gColor'">{{scope.row.phaseprofit >= 0? '+'+scope.row.phaseprofit:scope.row.phaseprofit}}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="syl" label="持有收益率" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.syl > 0" class="rColor">{{'+'+scope.row.syl+ "%"}}</span>
            <span v-else-if="scope.row.syl < 0" class="gColor">{{scope.row.syl+ "%"}}</span>
            <span v-else>{{scope.row.syl =='--'?'--':scope.row.syl+ "%"}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operate" label="操作" width="214">
          <template slot-scope="scope">
            <div class="btnFour">
              <span v-if="scope.row.fundstatus == '0' ||scope.row.fundstatus == '1'||scope.row.fundstatus == '6'||scope.row.fundstatus == '7'||scope.row.fundstatus == '8'||scope.row.fundstatus == 'b'" class="table-single-btn-normal" @click="fundHoldBuy(scope.row)">买</span>
              <span v-else class="table-single-btn-forbid">买</span>
              <span v-if="scope.row.availbal != '0.00' && (scope.row.fundstatus == '0' ||scope.row.fundstatus == '5'||scope.row.fundstatus == '7'||scope.row.fundstatus == '8'||scope.row.fundstatus == 'b')" class="table-single-btn-normal" @click="publicFundSell(scope.row)">卖</span>
              <span v-else class="table-single-btn-forbid">卖</span>
              <span v-if="scope.row.availbal !='0.00'" class="table-single-btn-normal" @click="publicFundTransform(scope.row)">转</span>
              <span v-else class="table-single-btn-forbid">转</span>
              <span class="table-single-btn-normal" @click="fundHoldDetail(scope.row)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "publicAssetsMessage",
  data () {
    return {
      radioPublic: '1',
      bankCardValue: 1,
      bankCardOptions: [
        {
          value: 1,
          label: '全部银行卡'
        },
      ],
      value: '',
      marketValue: 'marketValue',
      marketOptions: [
        {
          value: 'marketValue',
          label: '当前市值排序'
        }, {
          value: 'profit',
          label: '持有收益排序'
        },
        {
          value: 'code',
          label: '基金代码排序'
        }

      ],
      searchInput: '',
      publicTableData: [],
      loading: true,
      dialogVisable1: false,
      fundcodeStr: '',//基金公告
      newFundLists: [],//加了基金公告
    }
  },
  mounted () {
    this.getBankCard()
    this.getPublicHoldMessage()
    // this.selectBankCard()
  },
  methods: {
    returnClick () {
      if (this.$route.params.value == "publicPurchase") {
        this.$router.push({
          name: 'publicPurchaseLists'
        })
      } else if (this.$route.params.value == "fixedManagement") {
        this.$router.push({
          name: 'fixedManagement'
        })
      } else if (this.$route.params.value == "publicRecord") {
        this.$router.push({
          name: 'publicRecord'
        })
      } else if (this.$route.params.value == "publicBuy") {
        this.$router.push({
          name: 'publicBuy'
        })
      }

    },

    fundHoldBuy (row) {
      this.$router.push({
        name: 'publicBuy',
        params: {
          fundMessage: row
        }

      })
    },
    // 转换
    publicFundTransform (row) {
      // this.dialogVisable1 = true
      this.$router.push({
        name: 'publicFundTransform',
        params: {
          fundMessage: row
        }
      })
    },
    publicFundSell (row) {
      this.$router.push({
        name: 'publicFundHoldSell',
        params: {
          fundMessage: row
        }
      })
    },
    // 详情
    fundHoldDetail (row) {
      this.$router.push({
        name: 'fundHoldDetails',
        params: {
          message: row
        }
      })
    },
    selectBankCard (value) {
      this.loading = true
      this.getPublicHoldMessage(value)
    },
    // 银行卡
    getBankCard () {
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        if(res.data.code == 200) {
          const bankLists = res.data.data
          if (bankLists && bankLists.length > 0) {
            // console.log(bankLists)
            let arr = [{ value: 0, label: '全部银行卡' }];//, { value: 1, label: '没有银行卡' }
            bankLists.forEach((item, i) => {
              item.name = this.$commonJs.getBankName(item.channelid).split("-")[1]// 建设银行
              let object = { value: item.depositaccount, label: item.name + '[' + item.depositaccount.substring(item.depositaccount.length - 4) + ']' }
              arr.push(object);
            });
            let resultarr = [...new Set(arr)];
            // console.log(resultarr);
            this.bankCardOptions = resultarr;
            this.bankCardValue = this.bankCardOptions[0].value
          }
        }
      }).catch(err => { })
    },
    // 持有基金
    getPublicHoldMessage (value) {
      this.$http.post(this.$apiPath.fundListNew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(async res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        const total = res.data.data
        if (total) {
          let arrOne = [] // 当前市值排序
          total.forEach(item => {
            if (value != 0 && value != item.depositaccount && value != undefined) {  // 筛选银行卡
              return
            }
            if (this.searchInput == '' || item.fundcode.indexOf(this.searchInput) != -1 || item.fundcodename.indexOf(this.searchInput) != -1) {
              item.navdate = this.$commonJs.getDateStrTh(item.navdate).split('/')[1] + '/' + this.$commonJs.getDateStrTh(item.navdate).split('/')[2]
              item.fundvol = item.fundvol ? parseFloat(item.fundvol).toFixed(2) : "--";
              item.availbal = item.availbal ? parseFloat(item.availbal).toFixed(2) : "--";
              item.mktvalue = item.mktvalue ? parseFloat(item.mktvalue).toFixed(2) : "--";
              item.yestdayprofit = item.yestdayprofit ? parseFloat(item.yestdayprofit).toFixed(2) : "--";
              if (item.yestdayprofit == 0.00) { item.yestdayprofit = item.yestdayprofit ? parseFloat(item.yestdayprofit.substr(1)).toFixed(2) : '--' }
              item.syl = Number(item.phasecostmoney) <= 0 || item.fundtype == "2" ? '--' : (Number(item.phaseprofit) / Number(item.phasecostmoney) * 100).toFixed(2);
              item.phaseprofit = item.phaseprofit ? parseFloat(item.phaseprofit).toFixed(2) : "--";
              arrOne.push(item)
              this.fundcodeStr += item.fundcode + ','
            }
          });
          if (this.marketValue == 'marketValue') {
            arrOne.sort(function (a, b) { return b.mktvalue - a.mktvalue });
          } else if (this.marketValue == 'profit') {
            arrOne.sort(function (a, b) { return b.phaseprofit - a.phaseprofit });
          } else if (this.marketValue == 'code') {
            arrOne.sort(function (a, b) { return a.fundcode - b.fundcode });
          }
          //   this.publicTableData = arrOne
          this.newFundLists = arrOne
          await this.getNotice(this.fundcodeStr.slice(0, -1))
        }
      }).catch(() => { })
    },
    // 排序
    reorder () {
      this.loading = true
      this.getPublicHoldMessage()
    },
    // 基金公告
    async getNotice (str) {
      await this.$http.get(this.$apiPath.getFundInfomationNewest, {
        fundCode: str
      }).then(res => {
        // console.log(res);
        if (res.status == 200 && res.data.length > 0) {
          this.newFundLists.forEach((item, i) => {
            for (var i = 0; i < res.data.length; i++) {
              if (item.fundcode == res.data[i].FundCode) {
                item.InfoTitle = res.data[i].InfoTitle
                item.noticeType = res.data[i].MS
                item.noticeTime = res.data[i].XGRQ
                item.noticeId = res.data[i].ID
              }
            }
          })
          //   this.publicTableData = this.newFundLists
        }
        this.publicTableData = this.newFundLists
        this.loading = false
      }).catch(err => { })
    },
    set_cell_style ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "text-align:left;";
      }
    },
  },
  watch: {
    searchInput () {
      this.loading = true
      this.getPublicHoldMessage()
    }
  },


}
</script>

<style lang="less">
.table-public {
  padding: 0;
  &-blue {
    width: 380px !important;
    border-color: @color !important;
    color: @color !important;
    font-size: 14px;
    line-height: 22px;
  }
  &-red {
    width: 380px !important;
    border-color: @rColor !important;
    color: @rColor !important;
    font-size: 14px;
    line-height: 22px;
  }
  th {
    .cell {
      padding: 0;
    }
  }
  .cell {
    padding: 0;
  }
}
</style>